export class SubscriptionCardModel {

  skuType: string;
  basicPrice: string;
  moduleCount: string;
  description: string;
  id: string;
  detailFlag: string;
  productName: string;
  isSingleQuantity: string;
  constructor() {
    this.skuType = undefined;
    this.basicPrice = undefined;
    this.moduleCount = undefined;
    this.description = undefined;
    this.id = undefined;
    this.detailFlag = undefined;
    this.productName = undefined;
    this.isSingleQuantity = undefined;
  }
}
